import * as core from '../../../../../../../core'

import { query } from './recent-value-creating-events.query'

export const RESOURCE = {
  payload: {
    alias: 'recent.value.creating.events',
    description:
      'Recent Cursor usage events that created measurable value. Not yet implemented.',
    name: 'Recent Value-Creating Events',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
